module.exports = __webpack_public_path__ + "img/201606188305_.pic_hd.98602a12.jpg";